import { Component, Input, OnInit } from '@angular/core';

import { ThumbValue } from '@shared/models';

@Component({
  selector: 'mojo-thumb',
  templateUrl: './thumb.component.html',
  styleUrls: ['./thumb.component.scss'],
})
export class ThumbComponent implements OnInit {
  @Input() type: ThumbValue;
  @Input() selected = false;
  @Input() raisedOnHover = false;
  @Input() raisedOnSelected = false;
  @Input() enableReviewSelection = true;
  @Input() buttonClass = 'btn-medium';

  isThumbUp: boolean;
  isThumbDown: boolean;

  ngOnInit(): void {
    this.isThumbUp = ThumbValue.UP === this.type;
    this.isThumbDown = ThumbValue.DOWN === this.type;
  }
}
